import React, { useState} from 'react';
import { Grid } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import SideNav from 'components/sideNav/SideNav';
import { useStyles } from './LayoutStyle';
import Header from 'components/header/Header';



const Layout = ({ children }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [drawerWidth, setDrawerWidth] = useState(247);
  const [onlyMobile, setOnlyMobile] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(!open);
    if(open){
      setDrawerWidth(247)
    }else{
      setDrawerWidth(104)
    }
  };

  const handleDrawerClose = () => {
    setOpen(false);
    setDrawerWidth(104)
  };

  const handelOnMobile = () => {
    setOnlyMobile(!onlyMobile)
    setDrawerWidth(247)
  }

  return (
    <Grid className={classes.root}>
      <CssBaseline />

      <Grid container item className={classes.mainBody}>

        <SideNav
          open={open}
          onlyMobile={onlyMobile}
          onMobileOpen={handelOnMobile}
          handleDrawerClose={handleDrawerClose}
          handleDrawerOpen={handleDrawerOpen}
        />
        <Grid item className={classes.content} sx={{
            flexGrow: 1,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}>
            <Header handelOnlyOnMobile={handelOnMobile}/>
            <div className='layoutChildren'>
              {children}
            </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Layout;
